module.exports = __webpack_public_path__ + "img/tim.73bfa7c4.jpg";